import useSWR from "swr";
import useSWRMutation from "swr/mutation";

import { sendRequest } from "../../helpers/fetchHandleError";

export const useGetShippingProfiles = (
  key = `${process.env.REACT_APP_CLOUDFLARE_HOST}/shipping-profiles`,
  option
) => {
  const res = useSWR(key, option);
  const { data } = res;
  // Filter out the 'page' property
  const shippingProfiles = data
    ? data.map(({ page, ...rest }) => rest).sort((a, b) => a.id - b.id)
    : [];

  return {
    ...res,
    data: shippingProfiles,
  };
};

export const useCreateShippingProfile = (option) =>
  useSWRMutation(
    `${process.env.REACT_APP_CLOUDFLARE_HOST}/shipping-profiles`,
    sendRequest,
    option
  );

export const useUpdateShippingProfile = (shippingProfileId, option) =>
  useSWRMutation(
    shippingProfileId
      ? `${process.env.REACT_APP_CLOUDFLARE_HOST}/shipping-profiles/${shippingProfileId}`
      : null,
    (url, config) => sendRequest(url, { ...config, method: "PUT" }),
    option
  );

export const useDeleteShippingProfile = (shippingProfileId, option) =>
  useSWRMutation(
    shippingProfileId
      ? `${process.env.REACT_APP_CLOUDFLARE_HOST}/shipping-profiles/${shippingProfileId}`
      : null,
    (url, config) => sendRequest(url, { ...config, method: "DELETE" }),
    option
  );
